<template>
  <div>
    <Head title="Campaign" />
          <h1 class="mb-8 text-3xl font-bold">Campaign</h1>
    <div class="flex items-center space-x-4">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Account Type:</label>
        <select v-model="form.account" class="form-select mt-1 w-full">
          <option v-for="account in accounts" :key="account.account_id" :value="account.account_id">
            {{ account.name }}
            </option>
        </select>
      </search-filter>
    <!-- </div> -->

    <!-- Date Filters -->
        <div>
          <label for="from_date" class="block text-sm font-medium text-gray-700">
            From Date
          </label>
          <input
            type="date"
            id="from_date"
            v-model="form.from_date"
            class="form-input mt-1 block w-full border-gray-300 rounded-md shadow-sm"
             @change="validateDateRange"
          />
        </div>

        <!-- To Date -->
        <div>
          <label for="to_date" class="block text-sm font-medium text-gray-700">
            To Date 
           <span v-if="dateError" class="text-red-500 mt-2">{{ dateError }}</span>

          </label>
          <input
            type="date"
            id="to_date"
            v-model="form.to_date"
            class="form-input mt-1 block w-full border-gray-300 rounded-md shadow-sm"
             @change="validateDateRange"
          />
        </div>
      </div>

  <!-- <Link
    class="btn-indigo relative flex items-center justify-center"
    href="/post/getcontent"
    :class="{ 'opacity-50 cursor-not-allowed': isDisabled }"
    :disabled="isDisabled"
    @click="handleClick"
  >
    <span v-if="!isLoading">
      <span></span>
      <span class="hidden md:inline">&nbsp;Pull New Posts</span>
    </span>
    <span v-else>
      <svg
        class="animate-spin h-5 w-5 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        ></path>
      </svg>
    </span>
  </Link> -->
  <!-- {{ campaign }} -->

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap table-auto">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Account</th>
          <th class="pb-4 pt-6 px-6" style="width:10%;" >Campaign Name</th>
          <th class="pb-4 pt-6 px-6" style="width:10%;" >Shortcode</th>
          <th class="pb-4 pt-6 px-6" style="width:10%;" >Adset Name</th>
         
          <th class="pb-4 pt-6 px-6" @click="toggleSort('time')">Created<br> time
            <span v-if="sortColumnTime === 'time'">
              <span v-if="this.form.sortTime === 'desc'">↑</span>
              <span v-else>↓</span>
            </span>
          </th>
          <th class="pb-4 pt-6 px-6 cursor-pointer" @click="toggleSort('status')">
            Status
            <span v-if="sortColumn === 'status'">
              <span v-if="this.form.sortOrder === 'ACTIVE'">↑</span>
              <span v-else>↓</span>
            </span>
          </th>
          <th class="pb-4 pt-6 px-6">Impressions</th>
          <th class="pb-4 pt-6 px-6">Clicks</th>
          <th class="pb-4 pt-6 px-6">Spend</th>
          <th class="pb-4 pt-6 px-6">Cpc</th>
          <th class="pb-4 pt-6 px-6">Cpm</th>
          <th class="pb-4 pt-6 px-6">Reach</th>
          <th class="pb-4 pt-6 px-6">Cpp</th>
          <th class="pb-4 pt-6 px-6">Website Roas</th>
          <th class="pb-4 pt-6 px-6">Purchase Roas</th>
        
        </tr>
        <tr v-for="(campaign) in campaign.data" :key="campaign.campaign_id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <!-- <td class="border-t px-6 py-4" >
            <a  v-if="content.media && content.media.shortcode" 
              class="flex items-center px-6 py-4 highlight-link" 
              :href="content.cntnt_url" 
              target="_blank">
              {{ content.cntnt_shortcode }}
            </a>
             <span v-else class="flex items-center px-6 py-4" >
              {{ content.cntnt_shortcode }}
             </span>
          </td> -->
          <td class="border-t">
          <span 
          class="flex items-center px-6 py-4 max-w-full overflow-hidden text-ellipsis whitespace-nowrap" 
            tabindex="-1"
          >
            {{ campaign.account[0].name }} 
            
            <button v-if="!campaign.shortcode" @click="openEditPopup(campaign)" class="ml-2 text-blue-500 hover:text-blue-700">
              ✏️
            </button>
          </span>
        </td>
        <td class="border-t"  >
            <span   :title="campaign.name" class="flex items-center px-6 py-4 max-w-full overflow-hidden text-ellipsis whitespace-nowrap"  tabindex="-1" >
                {{ truncatedName(campaign.name) }}
            </span>
        </td>
        <td class="border-t"  >
          <span 
              v-if="campaign.shortcode" 
              :title="campaign.name"
              class="flex items-center px-6 py-4 max-w-full overflow-hidden text-ellipsis whitespace-nowrap"
              tabindex="-1"
            >
              {{ campaign.shortcode}}
            </span>
            <span v-else>
              N/A
            </span>
        </td>
       
        <td class="border-t">

        <a 
          v-if="campaign.adset && campaign.adset[0] && campaign.adset[0].name" 
          :href="`/adset?campaign_id=${campaign.campaign_id}`" 
          class="flex items-center px-6 py-4 max-w-full bg-blue-300 overflow-hidden text-ellipsis whitespace-nowrap"
          :title="campaign.adset[0].name"
          tabindex="-1"
        >
          {{ truncatedName(campaign.adset[0].name) }} 
        </a>
        <span 
          v-else 
          class="flex items-center px-6 py-4 max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-gray-400"
        >
          <!-- No Name Available -->
           N/A
        </span>
      </td>

        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="campaign.created_time">{{ campaign.created_time }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="campaign.status">{{ campaign.status }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="campaign.impressions">{{ campaign.impressions }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="campaign.clicks">{{ campaign.clicks }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="campaign.spend">{{ campaign.spend }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="campaign.cpc">{{ campaign.cpc }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="campaign.cpm">{{ campaign.cpm }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="campaign.reach">{{ campaign.reach }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="campaign.cpp">{{ campaign.cpp }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="campaign.website_purchase_roas">{{ campaign.website_purchase_roas }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="campaign.purchase_roas">{{ campaign.purchase_roas }}</span>
                <span v-else>N/A</span>
            </span>
        </td>

          <!-- <td class="w-px border-t">
              <span class="flex items-center px-4"  tabindex="-1">  {{ campaign.date_stop }}</span>
          </td> -->
          <!-- Action Icon -->
          <!-- <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="`/post/${content.cntnt_id}/edit`" tabindex="-1">
                  <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
          </td> -->
      </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="campaign.links" />

    <!-- Modal -->
  <div v-if="showPopup " class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white rounded-2xl shadow-xl p-6 w-full max-w-md">
      <h2 class="text-xl font-semibold mb-4">Link Campaign to Instagram Post </h2>

      <!-- Account Dropdown -->
      <label class="block mb-2 text-sm font-medium">Choose Account</label>
      <v-select
        v-model="selectedAccount"
        :options="instaAccounts"
        label="name"
        :reduce="instaAccounts => instaAccounts.id"
        placeholder="Select Account"
        @input="fetchDropdownData"
        class="mb-4"
      />

      <!-- Reel Dropdown -->
      <label class="block mb-2 text-sm font-medium">Choose Post</label>
      <v-select
        v-model="selectedReel"
        :options="reels"
        label="name"
        :reduce="reel => reel.name"
        placeholder="Select Reel"
        class="mb-4"
      />

      <div class="flex justify-end gap-2">
        <button @click="closePopup" class="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300">Cancel</button>

        <button @click="saveChanges" class="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700">Save </button>
      </div>
    </div>
  </div>

  </div>

  
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import axios from 'axios';

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
    vSelect
  },
  layout: Layout,
  props: {
    filters: Array,
    campaign: Object,
    accounts: Array,
    instaAccounts: Array,
  },
  data() {
    return {
      showPopup: false,
      selectedCampaign: null,
      selectedAccount: null,
      selectedReel: null,
      reels: [],
      instaAccounts:[],
      form: {
        search: this.filters.search,
        account: this.filters.account,
        sortOrder: this.filters.sortOrder,
        sortTime: this.filters.sortTime,
        from_date: this.filters.from_date || '',
        to_date: this.filters.to_date || '', 
      },
      isDisabled: false,
      isLoading: false,
      sortColumn: 'status', 
      sortColumnTime: 'time', 
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('campaign', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    toggleSort(column) {
        // If the same column is clicked again, toggle the order
        if (column == 'status' &&  this.sortColumn === 'status') {
          this.form.sortOrder = this.form.sortOrder === 'PAUSED' ? 'ACTIVE' : 'PAUSED';
        }
        if (column == 'time' && this.sortColumnTime === 'time') {
          this.form.sortTime = this.form.sortTime === 'asc' ? 'desc' : 'asc';
        } 
    },
    truncatedName(text) {
      const maxLength = 50;
      const name = text || '';
      return name.length > maxLength ? name.substring(0, maxLength) + '...' : name;
    },
    validateDateRange() {
      if (this.form.from_date && this.form.to_date) {
        const fromDate = new Date(this.form.from_date);
        const toDate = new Date(this.form.to_date);

        if (fromDate > toDate) {
          this.dateError = 'From Date cannot be greater than To Date.';
        } else {
          this.dateError = ''; // Clear error if valid
        }
      }
    },
    reset() {
      this.form = mapValues(this.form, () => null);
      this.sortColumn = null;
      this.form.sortOrder = 'ACTIVE';
    },
    openEditPopup(campaign) {
      this.selectedCampaign = campaign;
      this.selectedAccount = campaign.account[0]?.id || null;
      this.selectedReel = campaign.reel_id || null;
      this.fetchDropdownData();
      this.showPopup = true;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    closePopup() {
      this.showPopup = false;
      this.selectedCampaign = null;
      this.selectedAccount = null;
      this.selectedReel = null;
    },fetchDropdownData() {
      if (!this.selectedAccount) return;
      console.log(this.selectedAccount);
      
      // axios.get('/api/accounts').then(res => this.accounts = res.data);

      axios.get('/api/reels', {
        params: { acct_id: this.selectedAccount }
      }).then(response => {
        console.log(response.data);
        this.reels = response.data;
      });     
      
      // axios.get('/api/reels').then(res => this.reels = res.data);
    },
    saveChanges() {
      axios.post('/api/update-campaign', {
        campaign_id: this.selectedCampaign.campaign_id,
        account_id: this.selectedAccount,
        shortcode: this.selectedReel
      }).then(() => {
        this.closePopup();
        // Refresh the table by re-fetching the campaigns
      
        this.$inertia.get('campaign', pickBy(this.form), {
          preserveState: false, // you can also use `true` if you want to keep scroll position
          preserveScroll: true
        });
      });
    }

  },
} 
</script>
<style scoped>
.bg-blue-300 {
  color: blue;
}
.bg-blue-600 {
  color: rgb(110, 110, 230);
}
.hover:bg-blue-700{
  color: rgb(82, 82, 228);
}

</style>